import React from 'react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'
import { VulnerabilityPolicy, VulnerabilityPolicyAction } from '.'

export const vulnerabilityPoliciesQuery = gql`
  query VulnerabilityPolicies(
    $organizationID: ID!
    $action: VulnerabilityPolicyAction!
  ) {
    vulnerabilityPolicies(organizationID: $organizationID, action: $action) {
      id
      name
      enabled
      rules {
        title
      }
      allRules
      applications {
        id
        name
      }
      allApplications
      serverEnvironments
      allServerEnvironments
      applicationImportance
      ruleSeverities
      remediationDays
      valid
      action
      timeBasedEnabled
      routeBasedEnabled
      autoVerificationType
    }
  }
`

export interface ChildProps {
  readonly loading: boolean
  readonly vulnerabilityPolicies: VulnerabilityPolicy[]
  readonly refetch: () => Promise<any>
}

interface Props {
  readonly organizationID: string
  readonly action: VulnerabilityPolicyAction
  readonly children: (props: ChildProps) => React.ReactNode
}

export function VulnerabilityPoliciesLoader({
  organizationID,
  action,
  children
}: Props) {
  return (
    <Query
      query={vulnerabilityPoliciesQuery}
      variables={{ organizationID, action }}
      errorPolicy="all"
    >
      {(result) => {
        const { data, error, loading, refetch } = result
        if (error) {
          throw new Error(error.message)
        }
        const vulnerabilityPolicies: VulnerabilityPolicy[] =
          !!data && !!data.vulnerabilityPolicies
            ? data.vulnerabilityPolicies.map(
                ({
                  id,
                  name,
                  enabled,
                  rules,
                  allRules,
                  applications,
                  allApplications,
                  serverEnvironments,
                  allServerEnvironments,
                  applicationImportance,
                  ruleSeverities,
                  remediationDays,
                  valid,
                  action,
                  timeBasedEnabled,
                  routeBasedEnabled,
                  autoVerificationType
                }) => ({
                  id,
                  name,
                  enabled,
                  rules,
                  allRules,
                  applications,
                  allApplications,
                  serverEnvironments,
                  allServerEnvironments,
                  applicationImportance,
                  ruleSeverities,
                  remediationDays,
                  valid,
                  action,
                  timeBasedEnabled,
                  routeBasedEnabled,
                  autoVerificationType
                })
              )
            : []
        return children({
          loading,
          vulnerabilityPolicies,
          refetch
        })
      }}
    </Query>
  )
}
